import { render, staticRenderFns } from "./851817e1-bf8b-46a3-b2c7-5f2927b34b61.vue?vue&type=template&id=483cec73&scoped=true"
import script from "./851817e1-bf8b-46a3-b2c7-5f2927b34b61.vue?vue&type=script&lang=ts"
export * from "./851817e1-bf8b-46a3-b2c7-5f2927b34b61.vue?vue&type=script&lang=ts"
import style0 from "./851817e1-bf8b-46a3-b2c7-5f2927b34b61.vue?vue&type=style&index=0&id=483cec73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483cec73",
  null
  
)

export default component.exports